import { render } from "./salesView.vue?vue&type=template&id=2b2e7d19&scoped=true"
import script from "./salesView.vue?vue&type=script&lang=js"
export * from "./salesView.vue?vue&type=script&lang=js"

import "./salesView.vue?vue&type=style&index=0&id=2b2e7d19&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2e7d19"]])

export default __exports__